<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Solicitud de Endosos</h4>
    </div>

    <div class="function-wrapper">
      <b-row class="mb-3">
        <b-col sm="6">
          <p class="text-primary"><b>Seleccione el tipo de endoso que desee:</b></p>
        </b-col>
        <b-col sm="6">
          <b-select :options="tiposEndosos" v-model="tipoEndoso" @change="setTipoEndoso" />
        </b-col>
      </b-row>
      <div v-if="tipoEndoso">
        <hr />

        <b-row class="mt-2">
          <b-col sm="12"> <b class="text-primary">Póliza: </b> {{ nroPoliza }} </b-col>
          <b-col sm="12">
            <div v-if="!selectAseguradoEnabled">
              <b class="text-primary">Asegurado: </b>
              <span>{{ nombreAsegurado }}</span>
            </div>
            <b-form inline v-else>
              <label class="mr-sm-2 text-primary font-weight-bold" for="inline-asegurados-select">Asegurado: </label>
              <b-select id="inline-asegurados-select" :options="asegurados" @change="setAseguradoSelected" />
            </b-form>
          </b-col>
        </b-row>

        <hr />

        <endoso-cambio-domicilio v-if="tipoEndoso == 1" :provincias="provincias" :nro-poliza="nroPoliza" />
        <endoso-datos-personales v-if="tipoEndoso == 2" :nro-poliza="nroPoliza" :asegurado="aseguradoSelected || { text: nombreAsegurado }" :tomador="tomador" />
        <endoso-cambio-matricula v-if="tipoEndoso == 3" :nro-poliza="nroPoliza" :asegurado="aseguradoSelected || { text: nombreAsegurado }" />
        <endoso-inc-exc-cobertura v-if="tipoEndoso == 4" :nro-poliza="nroPoliza" :tomador="tomador" />
        <endoso-cambio-productor v-if="tipoEndoso == 5" :nro-poliza="nroPoliza" :tomador="tomador" />
        <endoso-cambio-condicion v-if="tipoEndoso == 6" :nro-poliza="nroPoliza" :tomador="tomador" />
        <endoso-inclu-exclu-items v-if="tipoEndoso == 7 && nombreAsegurado == 'Según nómina'" :tomador="tomador" :nro-poliza="nroPoliza" />
        <div class="alert alert-info text-center" v-if="tipoEndoso == 7 && nombreAsegurado != 'Según nómina'">Este tipo de endoso no se encuentra disponible en pólizas individuales</div>
      </div>
    </div>
  </div>
</template>

<script>
import EndosoCambioDomicilio from './Endosos/EndosoCambioDomicilio';
import EndosoDatosPersonales from './Endosos/EndosoDatosPersonales';
import EndosoCambioMatricula from './Endosos/EndosoCambioMatricula';
import EndosoIncExcCobertura from './Endosos/EndosoIncExcCobertura';
import EndosoCambioProductor from './Endosos/EndosoCambioProductor';
import EndosoCambioCondicion from './Endosos/EndosoCambioCondicion';
import EndosoIncluExcluItems from './Endosos/EndosoIncluExcluItems';

export default {
  components: {
    EndosoCambioDomicilio,
    EndosoDatosPersonales,
    EndosoCambioMatricula,
    EndosoIncExcCobertura,
    EndosoCambioProductor,
    EndosoCambioCondicion,
    EndosoIncluExcluItems,
  },
  props: {
    tomador: {
      type: String | Number,
    },
    nroPoliza: {
      type: String | Number,
    },
    nombreAsegurado: {
      type: String,
    },
    endoso: {
      type: String | Number,
    },
  },
  data() {
    return {
      tipoEndoso: null,
      visible: false,
      tiposEndosos: [
        { text: 'Cambio de Domicilio', value: 1 },
        { text: 'Corrección de Datos Personales', value: 2 },
        { text: 'Cambio / Incorporación de Matrícula', value: 3 },
        { text: 'Inclusión / Exclusión de Cobertura', value: 4 },
        { text: 'Cambio de Productor / Organizador', value: 5 },
        { text: 'Cambio de Condición Fiscal', value: 6 },
        { text: 'Inclusión / Exclusión de Items', value: 7 },
      ],
      provincias: [],
      aseguradoSelected: null,
      asegurados: [],
    };
  },
  methods: {
    deleteTipoEndoso : function() {
      if (this.$role(['productor', 'organizador'])) {
          delete this.tiposEndosos[4]; //Elimina la opción  "Cambio de Productor / Organizador"
      }
      
    },
    setTipoEndoso: async function (tipo) {
      location.hash = '#anchor-endosos';
      if (tipo == 1 || tipo == 2) {
        this.getProvincias();
      }
    },
    getProvincias() {
      return this.$api('tablas/provincias').then((res) => {
        this.provincias = res.data.map((item) => ({
          text: item.provincia,
          value: item.cod_dpto,
        }));
      });
    },
    setAseguradoSelected(val) {
      this.aseguradoSelected = this.asegurados.find((el) => el.value == val);
    },
  },
  computed: {
    selectAseguradoEnabled() {
      const conditions = {
        nombreAsegurado: this.nombreAsegurado == 'Según nómina',
        tipoEndoso: this.tipoEndoso == 2 || this.tipoEndoso == 3,
      };
      return Object.values(conditions).every((cond) => cond == true);
    },
  },

  watch: {
    selectAseguradoEnabled: async function (val) {
      if (val) {
        this.asegurados = await this.$api(`polizas/asegurados/${this.nroPoliza}/${this.endoso}`).then((res) => {
          return res.data.map((item) => ({
            text: 'Item Nro.: ' + item.nro_item + ' | Doc.: ' + item.documento + ' | Nombre: ' + item.nombre,
            value: item.cod_aseg,
          }));
        });
      }
    },
  },
  created() {
    this.deleteTipoEndoso();
  },
};
</script>
